import { render, staticRenderFns } from "./miniStatsDashboard.vue?vue&type=template&id=ecb2fcb2&scoped=true"
import script from "./miniStatsDashboard.vue?vue&type=script&lang=js"
export * from "./miniStatsDashboard.vue?vue&type=script&lang=js"
import style0 from "./miniStatsDashboard.vue?vue&type=style&index=0&id=ecb2fcb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb2fcb2",
  null
  
)

export default component.exports